import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
    {
		path: '/',
		component: resolve => require(['@/page/PandaFood.vue'], resolve),
	},
    {
		path: '/Login',
		component: resolve => require(['@/page/Login.vue'], resolve),
	}, {
		path: '/center',
		component: resolve => require(['@/page/center.vue'], resolve),
	},
    {
		path: '/index',
		component: resolve => require(['@/page/index.vue'], resolve),
	},
	// 用户协议
	{
		path: '/agreement',
		component: resolve => require(['@/page/agreement.vue'], resolve)
	},
	// 修改个人信息
	{
		path: '/edit_info',
		component: resolve => require(['@/page/edit_info.vue'], resolve)
	},
	// 创建店铺 - 填写信息
	{
		path: '/create_store/create_store_info',
		component: resolve => require(['@/page/create_store/create_store_info.vue'], resolve)
	},
	// 创建店铺 - 支付
	{
		path: '/create_store/create_store_pay',
		component: resolve => require(['@/page/create_store/create_store_pay.vue'], resolve)
	},
	// 创建店铺 - 合同详情/软件协议
	{
		path: '/create_store/software_contract',
		component: resolve => require(['@/page/create_store/software_contract.vue'], resolve)
	},
	{
		path: '/index',
		component: resolve => require(['@/page/index.vue'], resolve),
		redirect: '/restaurant/store_setup',
		children: [
			// 系统
			{
				path: '/restaurant/manage',
				component: resolve => require(['@/page/restaurant/manage.vue'], resolve)
			}, // 资源管理
			// 版本审核修改指引
			{
				path: '/restaurant/guide',
				component: resolve => require(['@/page/restaurant/guide.vue'], resolve)
			}, // 
			// 二维码
			{
				path: '/restaurant/wechat',
				component: resolve => require(['@/page/restaurant/wechat.vue'], resolve)
			}, // 
			// 消息中心
			{
				path: '/restaurant/noticeCenter',
				component: resolve => require(['@/page/restaurant/noticeCenter.vue'], resolve)
			}, // 
			// 餐饮模板 ↓ 
			{
				path: '/restaurant/clerk_manage',
				component: resolve => require(['@/page/restaurant/clerk_manage.vue'], resolve)
			}, // 店员管理
			{
				path: '/restaurant/add_clerk',
				component: resolve => require(['@/page/restaurant/add_clerk.vue'], resolve)
			}, // 店员管理 - 添加店员
			{
				path: '/restaurant/billing_data',
				component: resolve => require(['@/page/restaurant/billing_data.vue'], resolve)
			}, // 账单数据
			{
				path: '/restaurant/b2c_billing_data',
				component: resolve => require(['@/page/restaurant/b2c_billing_data.vue'], resolve)
			}, // b2c账单数据
			{
				path: '/restaurant/b2c_wx_user',
				component: resolve => require(['@/page/restaurant/b2c_wx_user.vue'], resolve)
			}, // b2c用户
			{
				path: '/restaurant/survey',
				component: resolve => require(['@/page/restaurant/survey.vue'], resolve)
			}, // 概况
			{
				path: '/restaurant/b2c_survey',
				component: resolve => require(['@/page/restaurant/b2c_survey.vue'], resolve)
			}, // b2c概况
			{
				path: '/restaurant/discount',
				component: resolve => require(['@/page/restaurant/discount.vue'], resolve)
			}, // 优惠促销
			{
				path: '/restaurant/reservation_setup',
				component: resolve => require(['@/page/restaurant/reservation_setup.vue'], resolve)
			}, // 订座设置
			{
				path: '/restaurant/store_setup',
				component: resolve => require(['@/page/restaurant/store_setup.vue'], resolve)
			}, // 店铺设置(餐饮)
			{
				path: '/restaurant/b2c_add_label',
				component: resolve => require(['@/page/restaurant/b2c_add_label.vue'], resolve)
			}, // b2c首页推荐商品
			{
				path: '/restaurant/b2c_add_recommend',
				component: resolve => require(['@/page/restaurant/b2c_add_recommend.vue'], resolve)
			}, // b2c首页推荐商品关联列表

			{
				path: '/restaurant/b2c_store_setup',
				component: resolve => require(['@/page/restaurant/b2c_store_setup.vue'], resolve)
			}, // 店铺设置(电商B2C)
			{
				path: '/restaurant/takeaway_setup',
				component: resolve => require(['@/page/restaurant/takeaway_setup.vue'], resolve)
			}, // 外卖设置
			{
				path: '/banner/swiper',
				component: resolve => require(['@/page/banner/swiper.vue'], resolve)
			}, // 轮播图
			{
				path: '/banner/module',
				component: resolve => require(['@/page/banner/module.vue'], resolve)
			}, // 小程序首页module 十个模块
			{
				path: '/banner/add_module',
				component: resolve => require(['@/page/banner/add_module.vue'], resolve)
			}, // 小程序首页module 十个模块
			{
				path: '/restaurant/table_code',
				component: resolve => require(['@/page/restaurant/table_code.vue'], resolve)
			}, // 桌码管理
			{
				path: '/restaurant/add_table_code',
				component: resolve => require(['@/page/restaurant/add_table_code.vue'], resolve)
			}, // 桌码管理 - 添加桌码
			{
				path: '/restaurant/table_code_detail',
				component: resolve => require(['@/page/restaurant/table_code_detail.vue'], resolve)
			}, // 桌码管理 - 桌码详情
			{
				path: '/restaurant/replace_style',
				component: resolve => require(['@/page/restaurant/replace_style.vue'], resolve)
			}, // 桌码管理 - 桌码样式
			{
				path: '/restaurant/wx_xiaocx',
				component: resolve => require(['@/page/restaurant/wx_xiaocx.vue'], resolve)
			}, // 外卖设置
			{
				path: '/restaurant/wx_bindApplet', // 绑定小程序授权
				component: resolve => require(['@/page/restaurant/wx_bindApplet.vue'], resolve)
			},
            {
				path: '/restaurant/wx_bind_result', // 授权 - 绑定微信小程序结果页面
				component: resolve => require(['@/page/restaurant/wx_bind_result.vue'], resolve)
			},
			{
				path: '/restaurant/register_xiaocx', // 绑定小程序
				component: resolve => require(['@/page/restaurant/register_xiaocx.vue'], resolve)
			},
            {
				path: '/restaurant/edit_mini_nickname',         // 修改微信小程序-名称
				component: resolve => require(['@/page/restaurant/edit_mini_nickname.vue'], resolve)
			},
            {
				path: '/restaurant/setting_categories',         // 修改微信小程序-名称
				component: resolve => require(['@/page/restaurant/setting_categories.vue'], resolve)
			},
            {
				path: '/restaurant/wx_filings',                 // 去备案
				component: resolve => require(['@/page/restaurant/wx_filings.vue'], resolve)
			},

            {	// 申请特约商户
				path: '/restaurant/wx_special_supplyer',
				component: resolve => require(['@/page/restaurant/wx_special_supplyer.vue'], resolve)
			},
			{
				path: '/restaurant/submit_xiaocx',
				component: resolve => require(['@/page/restaurant/submit_xiaocx.vue'], resolve)
			}, // 注册小程序
			{
				path: '/restaurant/wx_authorization',
				component: resolve => require(['@/page/restaurant/wx_authorization.vue'], resolve)
			}, // 体验小程序
			{
				path: '/banner/add_swiper',
				component: resolve => require(['@/page/banner/add_swiper.vue'], resolve)
			}, // 添加轮播
			{
				path: '/restaurant/commodity_manage',
				component: resolve => require(['@/page/restaurant/commodity_manage.vue'], resolve)
			}, // 菜品管理
			{
				path: '/restaurant/add_shop',
				component: resolve => require(['@/page/restaurant/add_shop.vue'], resolve)
			}, // 菜品管理 - 添加菜品
			{
				path: '/restaurant/commodity_classify',
				component: resolve => require(['@/page/restaurant/commodity_classify.vue'], resolve)
			}, // 菜品分类
			{
				path: '/goods/b2c_commodity_classify',
				component: resolve => require(['@/page/goods/b2c_commodity_classify.vue'], resolve)
			}, // b2c商品分类列表
			{
				path: '/goods/b2c_add_classify',
				component: resolve => require(['@/page/goods/b2c_add_classify.vue'], resolve)
			}, // b2c添加商品分类

			{
				path: '/restaurant/add_classify',
				component: resolve => require(['@/page/restaurant/add_classify.vue'], resolve)
			}, // 菜品分类 - 添加分类 
			{
				path: '/restaurant/relation_shop',
				component: resolve => require(['@/page/restaurant/relation_shop.vue'], resolve)
			}, // 菜品分类 - 关联菜品 /restaurant/add_relation_shop
			{
				path: '/restaurant/add_relation_shop',
				component: resolve => require(['@/page/restaurant/add_relation_shop.vue'], resolve)
			}, // 菜品分类 - 关联菜品 - 添加关联产品
			{
				path: '/restaurant/take_out',
				component: resolve => require(['@/page/restaurant/take_out.vue'], resolve)
			}, // 订单 - 外卖订单 
			{
				path: '/restaurant/take_out_detail',
				component: resolve => require(['@/page/restaurant/take_out_detail.vue'], resolve)
			}, // 订单 - 外卖订单 - 订单详情
			{
				path: '/restaurant/tang_food',
				component: resolve => require(['@/page/restaurant/tang_food.vue'], resolve)
			}, // 订单 - 堂食订单 
			{
				path: '/restaurant/tang_food_detail',
				component: resolve => require(['@/page/restaurant/tang_food_detail.vue'], resolve)
			}, // 订单 - 堂食订单 - 订单详情
			{
				path: '/restaurant/store_pay',
				component: resolve => require(['@/page/restaurant/store_pay.vue'], resolve)
			}, // 订单 - 店内付款 
			{
				path: '/restaurant/wx_user',
				component: resolve => require(['@/page/restaurant/wx_user.vue'], resolve)
			}, // 用户 - 餐饮 - 微信用户
			{
				path: '/restaurant/wx_user_detail',
				component: resolve => require(['@/page/restaurant/wx_user_detail.vue'], resolve)
			}, // 用户 - 微信用户 - 用户详情
			{
				path: '/restaurant/btc_user',
				component: resolve => require(['@/page/restaurant/btc_user.vue'], resolve)
			}, // 用户 - 商城 - 微信用户
			{
				path: '/restaurant/btc_user_detail',
				component: resolve => require(['@/page/restaurant/btc_user_detail.vue'], resolve)
			}, // 用户 - 微信用户 - 用户详情
			{
				path: '/restaurant/account_info',
				component: resolve => require(['@/page/restaurant/account_info.vue'], resolve)
			}, // 用户 - 微信用户 - 账户信息
			{
				path: '/restaurant/printer_manage',
				component: resolve => require(['@/page/restaurant/printer_manage.vue'], resolve)
			}, // 首页 - 打印机管理 
			{
				path: '/restaurant/add_printer',
				component: resolve => require(['@/page/restaurant/add_printer.vue'], resolve)
			}, // 首页 - 打印机管理 - 添加打印机
			{
				path: '/restaurant/configure_ticket',
				component: resolve => require(['@/page/restaurant/configure_ticket.vue'], resolve)
			}, // 首页 - 打印机管理 - 配置打印小票
			{
				path: '/restaurant/printer_detail',
				component: resolve => require(['@/page/restaurant/printer_detail.vue'], resolve)
			}, // 首页 - 打印机管理 - 打印机详情
			// 订单
			{
				path: '/order/order_detail',
				component: resolve => require(['@/page/order/order_detail.vue'], resolve)
			}, // 订单详情
			{
				path: '/order/b2c_booking',
				component: resolve => require(['@/page/order/b2c_booking.vue'], resolve)
			}, // 拼团订单列表
			{
				path: '/order/b2c_booking_detail',
				component: resolve => require(['@/page/order/b2c_booking_detail.vue'], resolve)
			}, // 拼团订单详情
			{
				path: '/order/order_list',
				component: resolve => require(['@/page/order/order_list.vue'], resolve)
			}, // 订单列表 
			{
				path: '/order/b2c_purchase',
				component: resolve => require(['@/page/order/b2c_purchase.vue'], resolve)
			}, // 退换订单列表 
			{
				path: '/order/b2c_purchase_detail',
				component: resolve => require(['@/page/order/b2c_purchase_detail.vue'], resolve)
			}, // 退换订单详情
			{
				path: '/order/reservation_list',
				component: resolve => require(['@/page/order/reservation_list.vue'], resolve)
			}, // 订座记录 
			{
				path: '/order/reservation_detail',
				component: resolve => require(['@/page/order/reservation_detail.vue'], resolve)
			}, // 订座记录 - 订单详情
			{
				path: '/order/stored_value',
				component: resolve => require(['@/page/order/stored_value.vue'], resolve)
			}, // 餐饮 - 储值订单 
			{
				path: '/order/btc_stored_value',
				component: resolve => require(['@/page/order/btc_stored_value.vue'], resolve)
			}, // 商城 - 储值订单 
			{
				path: '/order/member_list',
				component: resolve => require(['@/page/order/member_list.vue'], resolve)
			}, // 会员卡订单 
			{
				path: '/order/b2c_vip_list',
				component: resolve => require(['@/page/order/b2c_vip_list.vue'], resolve)
			}, // b2c会员卡订单 

			// 营销 
			{
				path: '/marketing/coupon_manage',
				component: resolve => require(['@/page/marketing/coupon_manage.vue'], resolve)
			}, // 优惠券管理
			{
				path: '/marketing/b2c_hot',
				component: resolve => require(['@/page/marketing/b2c_hot.vue'], resolve)
			}, // 设置热门词汇
			{
				path: '/marketing/b2c_coupon_manage',
				component: resolve => require(['@/page/marketing/b2c_coupon_manage.vue'], resolve)
			}, // btc优惠券管理

			{
				path: '/marketing/add_coupon',
				component: resolve => require(['@/page/marketing/add_coupon.vue'], resolve)
			}, // 优惠券管理 - 添加优惠券

			{
				path: '/marketing/b2c_add_coupon',
				component: resolve => require(['@/page/marketing/b2c_add_coupon.vue'], resolve)
			}, // btc优惠券管理 - 添加优惠券

			{
				path: '/marketing/b2c_coupon_detail',
				component: resolve => require(['@/page/marketing/b2c_coupon_detail.vue'], resolve)
			}, // 优惠券管理 - 优惠券详情
			{
				path: '/marketing/coupon_detail',
				component: resolve => require(['@/page/marketing/coupon_detail.vue'], resolve)
			}, // 优惠券管理 - 优惠券详情
			{
				path: '/marketing/receive_coupon',
				component: resolve => require(['@/page/marketing/receive_coupon.vue'], resolve)
			}, // 优惠券管理 - 领取列表
			{
				path: '/marketing/b2c_group_list',
				component: resolve => require(['@/page/marketing/b2c_group_list.vue'], resolve)
			}, // b2c拼团管理列表
			{
				path: '/marketing/b2c_group_detail',
				component: resolve => require(['@/page/marketing/b2c_group_detail.vue'], resolve)
			}, // b2c拼团管理详情
			{
				path: '/marketing/b2c_group_seckill',
				component: resolve => require(['@/page/marketing/b2c_group_seckill.vue'], resolve)
			}, // b2c秒杀列表
			{
				path: '/marketing/b2c_group_add_seckill',
				component: resolve => require(['@/page/marketing/b2c_group_add_seckill.vue'], resolve)
			}, // b2c添加秒杀
			{
				path: '/marketing/b2c_vip_mange',
				component: resolve => require(['@/page/marketing/b2c_vip_mange.vue'], resolve)
			}, // b2c会员卡管理列表   
			{
				path: '/marketing/b2c_vip_detail',
				component: resolve => require(['@/page/marketing/b2c_vip_detail.vue'], resolve)
			}, // b2c添加会员卡管理
			{
				path: '/marketing/b2c_vip_info',
				component: resolve => require(['@/page/marketing/b2c_vip_info.vue'], resolve)
			}, // b2c会员卡管理详情
			{
				path: '/marketing/b2c_vip_get_detail',
				component: resolve => require(['@/page/marketing/b2c_vip_get_detail.vue'], resolve)
			}, // b2c会员卡领取详情
			{
				path: '/marketing/b2c_distribution',
				component: resolve => require(['@/page/marketing/b2c_distribution.vue'], resolve)
			}, // b2c分销管理
			{
				path: '/marketing/b2c_theme_category',
				component: resolve => require(['@/page/marketing/b2c_theme_category.vue'], resolve)
			}, // b2c主题活动 活动类别
			{
				path: '/marketing/b2c_distribution_detail',
				component: resolve => require(['@/page/marketing/b2c_distribution_detail.vue'], resolve)
			}, // b2c分销管理等级详情
			{
				path: '/marketing/b2c_earnings_detail',
				component: resolve => require(['@/page/marketing/b2c_earnings_detail.vue'], resolve)
			}, // b2c分销管理收益记录详情页
			{
				path: '/marketing/b2c_user_detail',
				component: resolve => require(['@/page/marketing/b2c_user_detail.vue'], resolve)
			}, // b2c分销管理用户详情
			{
				path: '/marketing/b2c_draw',
				component: resolve => require(['@/page/marketing/b2c_draw.vue'], resolve)
			}, // b2c营销 抽奖活动
			{
				path: '/marketing/b2c_theme',
				component: resolve => require(['@/page/marketing/b2c_theme.vue'], resolve)
			}, // b2c营销 主题活动
			{
				path: '/marketing/b2c_theme_add',
				component: resolve => require(['@/page/marketing/b2c_theme_add.vue'], resolve)
			}, // b2c营销 添加主题活动


			{
				path: '/marketing/b2c_add_draw',
				component: resolve => require(['@/page/marketing/b2c_add_draw.vue'], resolve)
			}, // b2c营销 添加抽奖活动

			{
				path: '/marketing/b2c_add_prize',
				component: resolve => require(['@/page/marketing/b2c_add_prize.vue'], resolve)
			}, // b2c营销 添加奖品
			{
				path: '/marketing/b2c_advertising',
				component: resolve => require(['@/page/marketing/b2c_advertising.vue'], resolve)
			}, // b2c营销首页弹窗广告

			{
				path: '/marketing/b2c_announcement',
				component: resolve => require(['@/page/marketing/b2c_announcement.vue'], resolve)
			}, // b2c营销公告消息
			{
				path: '/marketing/b2c_first',
				component: resolve => require(['@/page/marketing/b2c_first.vue'], resolve)
			}, // b2c首单优惠
			{
				path: '/marketing/member_manage',
				component: resolve => require(['@/page/marketing/member_manage.vue'], resolve)
			}, // 会员卡管理 
            {
				path: '/marketing/member_manage_goods_price',
				component: resolve => require(['@/page/marketing/member_manage_goods_price.vue'], resolve)
			}, // 会员卡管理 - 设置商品价格
			{
				path: '/marketing/add_member',
				component: resolve => require(['@/page/marketing/add_member.vue'], resolve)
			}, // 会员卡管理 - 添加会员卡
			{
				path: '/marketing/member_detail',
				component: resolve => require(['@/page/marketing/member_detail.vue'], resolve)
			}, // 会员卡管理 - 会员详情
			{
				path: '/marketing/first_offer',
				component: resolve => require(['@/page/marketing/first_offer.vue'], resolve)
			}, // 首次优惠 
			{
				path: '/marketing/special_day',
				component: resolve => require(['@/page/marketing/special_day.vue'], resolve)
			}, // 优惠日 
			{
				path: '/marketing/recharge_manage',
				component: resolve => require(['@/page/marketing/recharge_manage.vue'], resolve)
			}, // 充值管理
			{
				path: '/marketing/add_recharge',
				component: resolve => require(['@/page/marketing/add_recharge.vue'], resolve)
			}, // 充值管理 - 添加充值
			{
				path: '/marketing/pay_politely',
				component: resolve => require(['@/page/marketing/pay_politely.vue'], resolve)
			}, // 支付有礼
			{
				path: '/marketing/push_coupons',
				component: resolve => require(['@/page/marketing/push_coupons.vue'], resolve)
			}, // 推送优惠券
			{
				path: '/marketing/add_push',
				component: resolve => require(['@/page/marketing/add_push.vue'], resolve)
			}, // 推送优惠券 - 添加推送

			//渠道
			{
				path: '/restaurant/h5_shops',
				component: resolve => require(['@/page/restaurant/h5_shops.vue'], resolve)
			}, // h5店铺、

			{
				path: '/restaurant/b2c_ecommendation',
				component: resolve => require(['@/page/restaurant/b2c_ecommendation.vue'], resolve)
			}, // 首页店铺推荐
			// 餐饮模板 ↑

			// 设置  
			{
				path: '/set_up/add_menu',
				component: resolve => require(['@/page/set_up/add_menu.vue'], resolve)
			},
			{
				path: '/set_up/menu_list',
				component: resolve => require(['@/page/set_up/menu_list.vue'], resolve)
			},
			{
				path: '/set_up/add_role',
				component: resolve => require(['@/page/set_up/add_role.vue'], resolve)
			},
			{
				path: '/set_up/role_list',
				component: resolve => require(['@/page/set_up/role_list.vue'], resolve)
			},
			{
				path: '/set_up/user_list',
				component: resolve => require(['@/page/set_up/user_list.vue'], resolve)
			},
			{
				path: '/set_up/addStaff',
				component: resolve => require(['@/page/set_up/addStaff.vue'], resolve)
			},

			// 个人中心设置
			{
				path: '/setting/staff',
				component: resolve => require(['@/page/setting/staff.vue'], resolve)
			},
			{
				path: '/setting/add_staff',
				component: resolve => require(['@/page/setting/add_staff.vue'], resolve)
			},
			{
				path: '/setting/order',
				component: resolve => require(['@/page/setting/order.vue'], resolve)
			},
			{
				path: '/setting/questions',
				component: resolve => require(['@/page/setting/questions.vue'], resolve)
			},
			{
				path: '/setting/add_questions',
				component: resolve => require(['@/page/setting/add_questions.vue'], resolve)
			},
			{
				path: '/setting/about_us',
				component: resolve => require(['@/page/setting/about_us.vue'], resolve)
			},
			{
				path: '/setting/invitation_rules',
				component: resolve => require(['@/page/setting/invitation_rules.vue'], resolve)
			}, // 邀请规则

			{
				path: '/setting/business_cooperation',
				component: resolve => require(['@/page/setting/business_cooperation.vue'], resolve)
			},

			// B2C商城商品
			{
				path: '/goods/b2c_commodity_manage',
				component: resolve => require(['@/page/goods/b2c_commodity_manage.vue'], resolve)
			}, // 商品管理
			{
				path: '/goods/b2c_add_shop',
				component: resolve => require(['@/page/goods/b2c_add_shop.vue'], resolve)
			}, // 商品管理 - 添加商品
			{
				path: '/goods/commodity_classify',
				component: resolve => require(['@/page/goods/commodity_classify.vue'], resolve)
			}, // 商品分类
			{
				path: '/goods/add_classification',
				component: resolve => require(['@/page/goods/add_classification.vue'], resolve)
			}, // 商品 分类广告

			{
				path: '/goods/btc_freightList',
				component: resolve => require(['@/page/goods/btc_freightList.vue'], resolve)
			}, // 运费模板
			{
				path: '/goods/btc_addFreight',
				component: resolve => require(['@/page/goods/btc_addFreight.vue'], resolve)
			}, // 添加运费模板
			{
				path: '/goods/add_classify',
				component: resolve => require(['@/page/goods/add_classify.vue'], resolve)
			}, // 商品分类 - 添加分类 
			{
				path: '/goods/commodity_specs',
				component: resolve => require(['@/page/goods/commodity_specs.vue'], resolve)
			}, // 商品管理 - 添加商品
			{
				path: '/goods/add_specs',
				component: resolve => require(['@/page/goods/add_specs.vue'], resolve)
			}, // 商品管理 - 添加商品
			{
				path: '/goods/commodity_label',
				component: resolve => require(['@/page/goods/commodity_label.vue'], resolve)
			}, // 商品管理 - 添加商品
			{
				path: '/goods/add_label',
				component: resolve => require(['@/page/goods/add_label.vue'], resolve)
			}, // 商品管理 - 添加商品
		]
	},
	],
})



// WEBPACK FOOTER //
// ./src/router/index.js